export default __webpack_public_path__ + "static/media/sharja-publishing-city.257e5638.png";